import React from 'react'

function Four04() {
  return (
    <div>
    <section className="internal-page-wrapper">
        <div className="container">
            <div className="row h-100 align-items-center justify-content-center text-center">
                <div className="col-12 mt-5 pt-5">
                    <h1 className="font-weight-bold">
                        404 <br />
                        The page you'lre looking for can'lt be found. <br /><br />
                    </h1>
                </div>
            </div>
        </div>
    </section>
</div>

  )
}

export default Four04